const pubManagerRouter = [

    /* 화면명 : 담당자 등록  : MSH_SR_001  */
    {
        path: "/publish/sh/MSH_SR_001", 
        name : 'PUB_MSH_SR_001',
        component: () => import('@/views/publish/sh/MSH_SR_001.vue')
    },

    /* 화면명 : 담당자 수정  : MSH_SR_002  */
    {
        path: "/publish/sh/MSH_SR_002", 
        name : 'PUB_MSH_SR_002',
        component: () => import('@/views/publish/sh/MSH_SR_002.vue')
    },


]
export {pubManagerRouter}